// Customizable Area Start
import React from "react";
import { Box, styled, Typography } from "@mui/material";
const ReadIcon = require("./read.svg").default;

type Props = {
  children: React.ReactNode;
  time: string;
  date: string;
  senderId: string;
  loggedInUserId: string;
  isSeen: boolean;
};

const MainWrapper = styled(Box)(() => ({
  display: "flex",
  maxWidth: "70%",
  "@media (max-width: 850px)": {
    maxWidth: "85%",
  },
  "@media (max-width: 414px)": {
    maxWidth: "90%",
  },
  "&.own_message": {
    justifyContent: "flex-end",
  },
}));

const MessageBubble = styled(Box)(() => ({
  padding: "10px 10px 8px",
  borderRadius: "0px 12px 12px 12px",
  backgroundColor: "#F1F5F9",
  position: "relative",
  display: "flex",
  gap: "4px",
  flexDirection: "column",
  width: "300px",
  "&::before": {
    content: "''",
    position: "absolute",
    left: "-10px",
    top: "0",
    width: "0",
    height: "0",
    border: "10px solid transparent",
    borderRightColor: "#F1F5F9",
    borderTopColor: "#F1F5F9",
  },
  "&.own_message": {
    borderRadius: "12px 0px 12px 12px",
    "&::before": {
      left: "unset",
      right: "-10px",
      borderLeftColor: "#F1F5F9",
      borderRightColor: "transparent",
    },
  },
}));

const MessageInfoWrapper = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: "3px",
}));

const MessageTime = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isOwnMessage",
})<{ isOwnMessage?: boolean }>(({ isOwnMessage }) => ({
  fontWeight: isOwnMessage ? 400 : 500,
  fontSize: "0.75rem",
  color: isOwnMessage ? "#64748B" : "#666668",
  justifyContent: "flex-end",
  lineHeight: 0.7,
  "@media (max-width: 414px)": {
    fontSize: "0.7rem",
  },
}));

const MessageBubbleComponent: React.FC<Props> = ({
  children,
  time,
  date,
  senderId,
  loggedInUserId,
  isSeen,
}) => {
  const isOwnMessage = loggedInUserId === senderId;

  return (
    <MainWrapper className={isOwnMessage ? "own_message" : ""}>
      <MessageBubble className={isOwnMessage ? "own_message" : ""}>
        {children}

        <MessageInfoWrapper>
          <MessageTime isOwnMessage={isOwnMessage} title={`${date} ${time}`}>
            {time}
          </MessageTime>
          {isOwnMessage && isSeen && <img src={ReadIcon} alt="Seen" />}
        </MessageInfoWrapper>
      </MessageBubble>
    </MainWrapper>
  );
};

export default MessageBubbleComponent;
// Customizable Area End
